import { useState } from 'react';
import { arrayOf, bool, shape, string } from 'prop-types';
import { processBoxSubscription } from '../../../../../utils/data';
import env from '../../../../../utils/env';
import { navigateTo } from '../../../../../utils/location';
import * as styles from '../../BoxSubscriptionPanel.module.css';

const ActionCta = ({
  hasPartialSelections,
  hasAdditionalPricing,
  boxSlug,
  isOpen,
  isProcessBoxEnabled,
  userExistingCart,
  boxSubscription,
  sortedProducts,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleFinishCustomizing = () => {
    navigateTo(`${env.envURL}/customize-box${boxSlug ? `/${boxSlug}` : ''}`);
  };

  const handleTrackOrder = () => {
    // TODO: Investigate where to get the tracking link from
    navigateTo(`${env.envURL}/my-account/orders`);
  };

  const handleProcessBox = async () => {
    if (hasActiveCart && boxSubscription?.customizeSaleId && sortedProducts?.length > 0) {
      setIsLoading(true);
      setError(null);

      const cartItemsToProcess = sortedProducts
        .filter((item) => item.choiceProductUuid !== null)
        .map((item) => ({
          saleUuid: item.saleUuid,
          catalogUuid: item.catalogUuid,
          productUuid: item.choiceProductUuid,
          quantity: item.choiceQuantity ?? 1,
          cartItemPreferences: {
            CUSTOMIZE_CHOICE_TYPE: item.choiceType ?? 'PRIMARY',
          },
        }));

      try {
        const result = await processBoxSubscription(
          userExistingCart.uuid,
          boxSubscription.customizeSaleId,
          cartItemsToProcess,
        );

        if (result && result?.error?.errors?.length > 0) {
          throw new Error('Failed to process box');
        }

        // TODO: Verify logic after sucessful checkout
        window.location.reload();
      } catch (err) {
        console.error('Error processing box:', err);
        setError(err.message || 'Failed to process box. Please try again.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (hasPartialSelections && isOpen) {
    return (
      <div className={styles.summaryDetails}>
        <button className={styles.actionCtaButton} onClick={handleFinishCustomizing}>
          Finish Customizing
        </button>
      </div>
    );
  }

  if (!isOpen) {
    return (
      <div className={styles.summaryDetails}>
        <button className={styles.actionCtaButton} onClick={handleTrackOrder}>
          Track Your Order
        </button>
      </div>
    );
  }

  if (!isProcessBoxEnabled || hasAdditionalPricing) {
    return null;
  }

  //TODO: MORE STATES WILL BE ADDED IN SEPARATE TICKETS.
  const hasActiveCart = Object.keys(userExistingCart ?? {}).length > 0;

  return (
    <div className={styles.summaryDetails}>
      {error && <div className={styles.errorMessage}>{error}</div>}
      <button
        className={styles.actionCtaButton}
        onClick={handleProcessBox}
        disabled={!hasActiveCart || isLoading}
      >
        {isLoading ? 'Processing...' : 'Process Box Now'}
      </button>
      <p className={styles.checkoutDescription}>
        Don&apos;t want to wait? Process your box now to get your box earlier.
      </p>
    </div>
  );
};

ActionCta.propTypes = {
  hasPartialSelections: bool.isRequired,
  hasAdditionalPricing: bool,
  boxSlug: string.isRequired,
  isOpen: bool.isRequired,
  isProcessBoxEnabled: bool.isRequired,
  userExistingCart: shape({}),
  boxSubscription: shape({}),
  sortedProducts: arrayOf(shape({})),
};

export default ActionCta;
